import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-dark-black border-b border-gray-800 sticky top-0 z-50" itemScope itemType="https://schema.org/Organization">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-discover="true" className="flex items-center">
            <img src="/images/favicon.webp" alt="Empire Wager" className="h-10 w-auto" itemProp="logo" />
          </Link>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" data-discover="true" className="text-gray-300 hover:text-toxic-orange transition-colors">
              Home
            </Link>
            <Link to="/guides" data-discover="true" className="text-gray-300 hover:text-toxic-orange transition-colors">
              Guides
            </Link>
            <Link to="/news" data-discover="true" className="text-gray-300 hover:text-toxic-orange transition-colors">
              News
            </Link>
            <Link to="/reviews" data-discover="true" className="text-gray-300 hover:text-toxic-orange transition-colors">
              Reviews
            </Link>
          </nav>

          <button
            className="md:hidden text-gray-300 hover:text-toxic-orange"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                data-discover="true"
                className="text-gray-300 hover:text-toxic-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/guides"
                data-discover="true"
                className="text-gray-300 hover:text-toxic-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Guides
              </Link>
              <Link
                to="/news"
                data-discover="true"
                className="text-gray-300 hover:text-toxic-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                News
              </Link>
              <Link
                to="/reviews"
                data-discover="true"
                className="text-gray-300 hover:text-toxic-orange transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Reviews
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

